
export default function resignation( state = [], action = {} ){

    switch( action.type ){
        case 'SAVE_RESIGNATION':
            return action.resignation
        case 'GET_RESIGNATION':
            return action.resignation
        case 'DELETE_RESIGNATION':
            return action.resignation
        case 'UPDATE_RESIGNATION_REASON':
            return action.resignation
        case 'APPROVE_RESIGNATION':
            return action.resignation
        case 'REJECT_RESIGNATION':
            return action.resignation
        case 'UPDATE_CHECK_VALUE':
            return action.resignation
        case 'GET_USER_RES':
            return action.resignation
        case 'UPDATE_RESIGNATION_LAST_DATE':
            return action.resignation
        case 'GET_DEPARTMENTS_RES':
            return action.resignation
        default: return state;
    }

}



// WEBPACK FOOTER //
// ./src/store/reducers/resignation/resignation.reducer.js